import { createContext } from "react";
import PageQuery from "common/types/PageQuery";
import { LibraryContext } from "./types";

const initialQuery: PageQuery = {
	filters: {},
	limit: 24,
	page: 0,
	search: {
		text: "",
		fields: [],
	},
	sort: "meta.name",
};

const context = createContext<LibraryContext>({
	objects: [],
	objectsQuery: initialQuery,
	pagedObjects: undefined,
	currentObject: undefined,
	loadingObjects: false,
	errorObjects: null,
	setCurrentObject: () => {
		throw new Error("setCurrentObject not implemented");
	},
	resetCurrentObject: () => {
		throw new Error("resetCurrentObject not implemented");
	},
	setObjectsQuery: () => {
		throw new Error("setObjectsQuery not implemented");
	},
	loadMoreObjects: () => {
		throw new Error("loadMoreObjects not implemented");
	},
	loadSingleObject: () => {
		throw new Error("loadSingleObject not implemented");
	},
	objectsCount: 0,
	
	allObjectsCache: [],

	groupedObjects: [],
	pagedGroupedObjects: undefined,
	loadingGroupedObjects: false,
	loadMoreGroupedObjects: () => {
		throw new Error("loadMoreGroupedObjects not implemented");
	},
	objectsBrowseLevel: null,

	materials: [],
	materialsBrowseLevel: null,
	materialsQuery: initialQuery,
	pagedMaterials: undefined,
	currentMaterial: undefined,
	loadingMaterials: false,
	errorMaterials: null,
	setCurrentMaterial: () => {
		throw new Error("setCurrentMaterial not implemented");
	},
	setMaterialsQuery: () => {
		throw new Error("setMaterialsQuery not implemented");
	},
	loadMoreMaterials: () => {
		throw new Error("loadMoreMaterials not implemented");
	},
	allMaterials: [],
	fetchAllMaterials: () => {
		throw new Error("fetchAllMaterials not implemented");
	},

	lights: [],
	lightsQuery: initialQuery,
	pagedLights: undefined,
	currentLight: undefined,
	loadingLights: false,
	errorLights: null,
	setCurrentLight: () => {
		throw new Error("setCurrentLight not implemented");
	},
	updateCurrentLight: () => {
		throw new Error("updateCurrentLight not implemented");
	},
	setLightsQuery: () => {
		throw new Error("setLightsQuery not implemented");
	},
	loadMoreLights: () => {
		throw new Error("loadMoreLights not implemented");
	},
	allLights: [],
	fetchAllLights: () => {
		throw new Error("fetchAllLights not implemented");
	},

	combinations: [],
	combinationsQuery: initialQuery,
	combinationClassificationFilter: { category: null, subcategory: null },
	setCombinationClassificationFilter: () => {
		throw new Error("setCombinationClassificationFilter not implemented");
	},
	combinationVisibility: "isPublic",
	setCombinationVisibility: () => {
		throw new Error("setCombinationVisibility not implemented");
	},
	pagedCombinations: undefined,
	currentCombination: undefined,
	loadingCombinations: false,
	errorCombinations: null,
	setCurrentCombination: () => {
		throw new Error("setCurrentCombination not implemented");
	},
	setCombinationsQuery: () => {
		throw new Error("setCombinationsQuery not implemented");
	},
	loadMoreCombinations: () => {
		throw new Error("loadMoreCombinations not implemented");
	},

} as any);

export default context;
